import { useEffect } from 'react'
import { useTheme } from '@/theme/useTheme'
import graphitLogo from '@/images/GraphitLogoSmall.png'

const PRODUCT_TITLE = 'Graphit'

/** Route-scoped browser identity. Never restore a previous tenant as a baseline. */
export default function BrandingDocument({ title }) {
  const { branding, resolved } = useTheme()
  const icon = branding.icon_url || (resolved === 'dark' && branding.dark_logo_url) || branding.logo_url || graphitLogo

  useEffect(() => {
    document.title = title ? `${title} · ${branding.application_name}` : branding.application_name
    let link = document.querySelector('link[rel="icon"]')
    if (!link) {
      link = document.createElement('link')
      link.rel = 'icon'
      document.head.appendChild(link)
    }
    // Assets may be PNG, JPEG or SVG; the former static SVG type must not survive.
    link.removeAttribute('type')
    link.href = icon
    const fallback = () => { link.href = graphitLogo }
    link.addEventListener('error', fallback, { once: true })
    return () => {
      link.removeEventListener('error', fallback)
      link.href = graphitLogo
      document.title = PRODUCT_TITLE
    }
  }, [branding.application_name, icon, title])

  return null
}
